import { ShowCaseWebContained } from './ShowCaseWebContained'
import { ShowCaseWebFullWidth } from './ShowCaseWebFullWidth'
import { IShowCaseWebProps } from './types'

export type { IShowCaseWebProps, ShowCaseWebLayout } from './types'

export const ShowCaseWeb = (props: IShowCaseWebProps) => {
  if (props.layout === 'heroCarouselFullWidth') {
    return <ShowCaseWebFullWidth {...props} />
  }

  return <ShowCaseWebContained {...props} />
}
